"use strict";

define('service/table',['appkit/service'], function (Service) {
  var TableService = Service.extend({
    replies: {
      'fixed:table': 'configureTableToFixed'
    },
    configureTableToFixed: function configureTableToFixed(table) {
      table.fixedHeader = true;
      table.fixedHeaderTopOffset = 41;
      table.fixedHeaderTopPosition = 40.5;
      table.fixedHeaderBackground = "#fcfcfc";
    }
  });
  return TableService;
});

